import { render, staticRenderFns } from "./CreateAwardModal.vue?vue&type=template&id=7dace071&scoped=true&"
import script from "./CreateAwardModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./CreateAwardModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CreateAwardModal.vue?vue&type=style&index=0&id=7dace071&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dace071",
  null
  
)

export default component.exports